import { render, staticRenderFns } from "./SmallPartner.vue?vue&type=template&id=0ffd0618"
import script from "./SmallPartner.vue?vue&type=script&lang=js"
export * from "./SmallPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports